// @ts-nocheck
import { createAsyncAction } from '../../../core/store/actionCreators';
import {
  FETCH_CORRESPONDENCE,
  FETCH_EVENTS,
  FETCH_EMAILS,
  FETCH_EMAILS_URL,
} from './eventActionTypes';
import EventService from '../services/EventService';
import CorrespondenceService from '../services/CorrespondenceService';
import AdobeCampaignService from '../services/AdobeCampaignService';

export const fetchEvents = createAsyncAction(FETCH_EVENTS, async userId => {
  const { data } = await EventService.fetchEvents(userId);
  return data;
});

export const fetchCorrespondence = createAsyncAction(FETCH_CORRESPONDENCE, async userId => {
  const { data } = await CorrespondenceService.fetchCorrespondence(userId);
  return data;
});

export const fetchCampaignEmails = createAsyncAction(FETCH_EMAILS, async (userId, userEmail) => {
  const { data } = await AdobeCampaignService.fetchCampaignEmails(userId, userEmail);
  return data;
});

export const fetchCampaignEmailsUrl = createAsyncAction(
  FETCH_EMAILS_URL,
  async (userId, userEmail) => {
    const { data } = await AdobeCampaignService.fetchCampaignEmailsUrl(userId, userEmail);
    return data;
  }
);
